module.exports = __webpack_public_path__ + "img/thunder.be798a80.jpg";